import LoaderBalls from 'components/LoaderBalls'
import React from 'react'

export default () => {
  return <div className='drift-widget-message--box--loader'>
    <LoaderBalls />
  </div>
}
